<template>
    <div>
        <template v-if="viewPage == true && leaveCrud == true">
            <form @submit.prevent="updateCompanyLeaveData">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Edit Company Leave </h1>
                </div>
                <div class="company-main">
                    <div class="company-inner">
                        <div class="form-group">
                            <label class="label block-label"> Title  <em class="required">*</em> </label>
                            <input v-model="form.title" type="text" name="title" class="form-control" :class="{ 'is-invalid': form.errors.has('title') }">
                            <has-error :form="form" field="title"></has-error>
                        </div>
                        <div class="form-group">
                            <label class="label block-label"> No. of Leaves  <em class="required">*</em> </label>
                            <input v-model="form.no_of_leaves" type="text" name="no_of_leaves" class="form-control" :class="{ 'is-invalid': form.errors.has('no_of_leaves') }">
                            <has-error :form="form" field="no_of_leaves"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Carry Forward <em class="required">*</em></label>
                            <select v-model="form.carry_forward" id="pick" name="carry_forward" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('carry_forward') }">
                                <option value="YES">Yes</option>
                                <option value="NO">No</option>
                            </select>
                            <has-error :form="form" field="carry_forward"></has-error>
                        </div>
                        <div class="form-group" v-if="form.carry_forward == 'Yes'">
                            <label class="label block-label"> Carry Leaves  <em class="required">*</em> </label>
                            <input v-model="form.carry_leaves" type="text" name="carry_leaves" class="form-control" :class="{ 'is-invalid': form.errors.has('carry_leaves') }">
                            <has-error :form="form" field="carry_leaves"></has-error>
                        </div>
                        <div class="form-group">
                            <label class="label block-label"> Gender <em class="required">*</em></label>
                            <select v-model="form.gender" name="gender" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('gender') }">
                                <option value="MALE">Male</option>
                                <option value="FEMALE">Female</option>
                                <option value="BOTH">Both</option>
                            </select>
                            <has-error :form="form" field="gender"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Segmentation <em class="required">*</em></label>
                            <select v-model="form.segmentation" name="segmentation" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('segmentation') }">
                                <option value="PAID">Paid</option>
                                <option value="UNPAID">Un-Paid</option>
                            </select>
                            <has-error :form="form" field="segmentation"></has-error>
                        </div>

                        <div class="form-group">
                            <label> Employment Status <em class="required">*</em></label>
                            <select v-model="form.employment_status" name="employment_status[]" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('employment_status') }" multiple>
                                <option value="PERMANENT">Permanent</option>
                                <option value="INTERN">Intern</option>
                                <option value="CONTRUCTUAL">Contructual</option>
                                <option value="PROBATION">Probation</option>
                                <option value="PIECE_RATE">Piece Rate</option>
                            </select>
                            <has-error :form="form" field="employment_status"></has-error>
                        </div>
                        <div class="form-group">
                            <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                            <router-link to="/companyLeaves" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="viewPage === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="viewPage === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                viewPage: null,
                leaveCrud: false,
                form: new Form({
                    'title':'',
                    'carry_forward':'',
                    'carry_leaves':'',
                    'no_of_leaves':'',
                    'gender':'',
                    'segmentation':'',
                    'employment_status':[],
                    'id' : this.$route.params.id,
                }),
            }
        },

        mounted(){
            this.$Progress.start();
            this.can('company_leaves|crud_company_leaves').then(result => {
                this.viewPage = result.company_leaves;
                this.leaveCrud = result.crud_company_leaves;
                this.$Progress.finish();
            }).then(result => {
                this.getSingleCompanyLeave();
                $('.selectpicker').selectpicker();
            });
        },

        methods: {
            getSingleCompanyLeave(){
                axios.get('/api/getCompanyLeave/'+this.form.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.title = res.data.title;
                        this.form.carry_forward = res.data.carry_forward;
                        this.form.carry_leaves = res.data.carry_leaves;
                        this.form.no_of_leaves = res.data.no_of_leaves;
                        this.form.gender = res.data.gender;
                        this.form.segmentation = res.data.segmentation;
                        this.form.employment_status = JSON.parse(res.data.employment_status);
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).then(res =>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                }).catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },
            updateCompanyLeaveData() {
                this.$Progress.start();
                this.form.put('/api/updateCompanyLeave')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Company Leave updated successfully');
                        this.$router.push('/companyLeaves');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }

                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
        }

    }
</script>
